import React from 'react';

const NoMatch = () => {
    return <h1>Nomatch works</h1>;
};
export default NoMatch;
